module.exports = __webpack_public_path__ + "img/image-confetti.1510e4a2.jpg";